import { z } from 'zod';

export const AudienceValueSchema = z.object({
  visible: z.boolean(),
});

export const AudienceKeyValPairSchema = z.record(AudienceValueSchema);

export const AudienceSchema = z.object({
  syncWithTemplate: z.boolean(),
  zones: AudienceKeyValPairSchema,
});

export type Audience = z.infer<typeof AudienceSchema>;
export type AudienceValue = z.infer<typeof AudienceValueSchema>;
export type AudienceKeyValPair = z.infer<typeof AudienceKeyValPairSchema>;
